import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import 'sal.js/dist/sal.css';
import sal from 'sal.js';

import ResImg from 'components/resImg';
import ResVideo from 'components/resVideo';

const Media = ({ blok }) => {
  const hasVideo = blok.mobile_video?.filename !== undefined || blok.video?.filename !== '';
  const aspectRatio = {
    desktop: blok?.aspect_ratio,
    mobile: blok?.aspect_ratio_mobile,
  };

  let mediaClasses = 'container';
  if (blok.fullscreen) {
    mediaClasses = 'h-mobile-fs xl:h-desktop-fs';
  }
  if (blok.fullscreen && blok.gutter) {
    mediaClasses = 'h-mobile-fs xl:h-desktop-fs container';
  }
  if (!blok.gutter && !blok.fullscreen) {
    mediaClasses = 'h-auto';
  }

  useEffect(() => {
    if (blok.animate) {
      sal({ threshold: 0.25 });
    }
  }, [blok.animate]);

  const isAnimate = blok.animate;

  return (
    <div
      className={`my-7 bg-primary lg:my-8 xl:my-10 ${mediaClasses}`}
      {...(isAnimate
        ? {
            'data-sal': 'slide-up',
            'data-sal-duration': '1000',
            'data-sal-delay': '0',
            'data-sal-easing': 'ease',
          }
        : {})}
    >
      {hasVideo ? (
        <ResVideo
          mobileVideo={blok.mobile_video}
          desktopVideo={blok.video}
          mobilePoster={blok.mobile_image}
          desktopPoster={blok.image}
          aspectRatio={aspectRatio}
        />
      ) : (
        <ResImg
          mobile={blok.mobile_image}
          desktop={blok.image}
          aspectRatio={aspectRatio}
          maxWidth={blok.fullscreen ? 3120 : 1920}
        />
      )}
    </div>
  );
};

Media.propTypes = {
  blok: PropTypes.object.isRequired,
};

export default Media;
